import type { IconName } from '@/components/icons'
import { ref, type Component } from 'vue'

type Toast = {
  message: string
  description?: string
  messageComponent?: Component
  actionButton?: {
    title: string
    action: () => void
  }
  icon?: IconName
  iconColor?: 'primary' | 'error'
  variant?: 'DARK' | 'WHITE'
  restrictedWidth?: boolean
}

const defaultConfig: Partial<Toast> = {
  restrictedWidth: true,
}

const toast = ref<Toast>({ message: '' })
const isOpened = ref(false)

export function useToast() {
  const showToast = (newToast: Toast) => {
    const timeoutDelay = isOpened.value ? 150 : 0

    isOpened.value = false

    setTimeout(() => {
      toast.value = { ...defaultConfig, ...newToast }
      isOpened.value = true
    }, timeoutDelay)
  }

  return { showToast, toast, isOpened }
}
